// extracted by mini-css-extract-plugin
export var sliderRange = "_pu-2";
export var sliderRoot = "_pu-0";
export var sliderThumb = "_pu-3";
export var sliderTrack = "_pu-1";